import elm from './elm';
import pubsub from './pubsub';

const alphaKeyMap = createAlphaKeyMap();
const numericKeyMap = createNumericKeyMap();

function createAlphaKeyMap() {
  const keyMap = {};
  const alphabet = 'abcdefghijklmnopqrstuvwxyz'.split('');

  for (let i = 0; i < 26; i++) {
    keyMap[65 + i] = alphabet[i];
  }

  return keyMap;
}

function createNumericKeyMap() {
  const keyMap = {};
  const numbers = '0123456789'.split('');

  for (let i = 0; i < 26; i++) {
    keyMap[48 + i] = numbers[i];
  }

  return keyMap;
}

function whichKey(event) {
  const keyCode = event.which;

  return alphaKeyMap[keyCode] || numericKeyMap[keyCode];
}

elm.on(window, 'keydown', (e) => {
  e.preventDefault();

  pubsub.publish('KeyPress', [null, whichKey(e)]);
});



// WEBPACK FOOTER //
// ./src/js/keyboard.js